var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDustbin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8713 2.53714H15.3273L13.7433 0.375H7.4073L5.8233 2.53714H0.279297V5.41998H20.8713V2.53714Z",
    fill: "#313C60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2873 6.41992H1.86328V22.9963H19.2873V6.41992ZM6.61528 18.672H5.03128V10.7442H6.61528V18.672ZM11.3673 18.672H9.78328V10.7442H11.3673V18.672ZM16.1193 18.672H14.5353V10.7442H16.1193V18.672Z",
    fill: "#313C60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDustbin);
export default __webpack_public_path__ + "static/media/Dustbin.e3aff6660f8deb8fafdba60818ff1df2.svg";
export { ForwardRef as ReactComponent };